import { isAssessmentUiOn } from "./navFlags";


const DEFAULT_ENTITY_LABELS = {
  brand: "Brand",
  audit: "Audit",
  product: "Product",
  market: "Market",
  category: "Category",
  categoryType: "Category Type",
  persona: "Persona",
  competitor: "Competitor",
  rank:"Visibility",
  brandPlaceHolder: "Nike",
  productPlaceHolder: "Nike Air Force 1",
  personaPlaceHolder:"e.g Marketing Manager",
  categoryTypePlaceHolder:"e.g Companies",
  categoryPlaceHolder:"e.g Athletic Apparel",
  purchaseCriteria: "Purchase Criteria",
  brandPillar:"Brand Pillars",
  productDimension:"Product Dimension",
  brandIndexScore: "Brand Index Score",
  productIndexScore:" Product Index Score",
  brandSnippets:"Brand Snippets",
  productSnippets:"Product Snippets",
  brandThemes:"Brand Themes",
  productThemes:"Product Themes",
  brandAttributes:"Brand Attributes",
  productAttributes:"Product Attributes",
  buyingJourney:"Buying Journey",
  postPurchase:"Post-Purchase",
  customer:"Customer",
  purchase:"Purchase",
  hasProductEntity: true,
  evaluatingLabel: "Evaluating"
};


let _cachedLabels = null;
let _cachedRaw = undefined;
let _cachedAssessmentUi = false;


let _tabSnapshot;
let _hasTabSnapshot = false;

// Users with feature_flags.is_assessment_ui_enabled see "Assessment" instead of "Audit" (a customer's own
// customer_ui_info.audit still wins). Read from the stored login user; cached on the raw string.
const ASSESSMENT_LABEL = "Assessment";
let _rawUserForFlag;
let _assessmentUi = false;

function getAssessmentUi() {
  try {
    const rawUser = localStorage.getItem("user");
    if (rawUser !== _rawUserForFlag) {
      _rawUserForFlag = rawUser;
      _assessmentUi = isAssessmentUiOn(rawUser ? JSON.parse(rawUser) : null);
    }
  } catch {
    _assessmentUi = false;
  }
  return _assessmentUi;
}

function buildLabels(customerUiInfo) {
  const base = getAssessmentUi()
    ? { ...DEFAULT_ENTITY_LABELS, audit: ASSESSMENT_LABEL }
    : DEFAULT_ENTITY_LABELS;
  return customerUiInfo ? { ...base, ...customerUiInfo } : base;
}

function resolveEntityLabels() {
  try {
    if (_hasTabSnapshot) {
      return buildLabels(_tabSnapshot);
    }

    const raw = localStorage.getItem("customer_ui_info");

    // Cache hit — localStorage hasn't changed, return cached object instantly
    // Cost: one string comparison ~0.001ms instead of JSON.parse ~0.1ms
    const assessmentUi = getAssessmentUi();
    if (raw === _cachedRaw && assessmentUi === _cachedAssessmentUi && _cachedLabels !== null) {
      return _cachedLabels;
    }

    // Cache miss — localStorage changed (login/logout), rebuild object once
    _cachedRaw = raw;
    _cachedAssessmentUi = assessmentUi;
    const customerUiInfo = raw ? JSON.parse(raw) : null;
    _cachedLabels = buildLabels(customerUiInfo);

    return _cachedLabels;
  } catch {
    return DEFAULT_ENTITY_LABELS;
  }
}

export function invalidateLabelCache() {
  _cachedLabels = null;
  _cachedRaw = undefined;
}
export function setEntityLabelsSource(customerUiInfo) {
  _tabSnapshot = customerUiInfo ?? null;
  _hasTabSnapshot = true;
}

export const ENTITY_LABELS = new Proxy(
  {},
  {
    get(_, key) {
      return resolveEntityLabels()[key];
    },
  }
);

export function mapLabel(label) {
  if (!label) return label;
  return label
    .replace(/\bCompany\/Brand\b/g, ENTITY_LABELS.brand)
    .replace(/\bBrand\b/g, ENTITY_LABELS.brand)
    .replace(/\bProduct\b/g, ENTITY_LABELS.product);
}

export function getEntityLabel(type) {
  if (type === "brand") return ENTITY_LABELS.brand;
  if (type === "product") return ENTITY_LABELS.product;
  return type;
}